module.exports = __webpack_public_path__ + "img/taiyuan.42c59e81.jpg";